var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"under-construccion d-flex flex-column justify-content-center"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"under-construccion-text-container"},[_c('vue-typer',{attrs:{"text":"Site under construction","repeat":0}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }